export default __webpack_public_path__ + "static/blogThumbnail-82966f38885c0a8999e54057ef8ef861.png";